import { ESortOrder, ISortState } from "components/Table/types";

const formatOrderingAPI = <T>({ column, order }: ISortState): T =>
  column && (order === ESortOrder.Ascending || order === ESortOrder.Descending)
    ? (`${order === ESortOrder.Descending ? "-" : ""}${column}` as T)
    : ("" as T);

export default formatOrderingAPI;
